export const lingua_en = {
  lang: "en",
  title: "3D SHIRT - Customized shirts 3d configurator",
  description: "Customized shirts 3d configurator",
  personalizza: "Customization",
  misure: "Measurements",
  tessuto: "Fabric",
  filtri: "Filters",
  scegliTessuto: "Select the fabric",
  cercaTessuto: "Search fabric...",
  inOfferta: "On sale",
  nonDisponibile: "Not available",
  colore: "Color",
  colori: "Colors",
  tuttiColori: "All colors",
  bianco: "White",
  celeste: "Light blue",
  altriColori: "Other colors",
  disegno: "Fabrics",
  disegni: "Fabrics",
  tuttiDisegni: "All fabrics",
  tintaUnita: "Solid color fabrics",
  righe: "Striped fabrics",
  quadretti: "Checked fabrics",
  fantasia: "Printed fabrics",
  materiale: "Fabric",
  materiali: "Fabrics",
  tuttiMateriali: "All fabrics",
  cotone: "Cotton",
  lino: "Linen",
  brand: "Brand",
  brands: "Brands",
  tuttiBrands: "All brands",
  codice: "Code",
  ordina: "Sort by price",
  basso: "Low to high",
  alto: "High to low",
  lato: "Side view",
  front: "Front view",
  retro: "Back view",
  piegata: "Folded view",
  extra: {
    tutti: "All products",
    selTaglia: "Select size",
    desc: "Description",
    correlati: "Related products",
  },
  bubble: {
    prima: "Clicca qui per tornare alla vista camicia.",
    seconda: "Trascina con il tasto SINISTRO del mouse per ruotare la camicia",
    terza: "Trascina con il tasto DESTRO del mouse per spostare la camicia.",
    quarta: "Muovi la ROTELLINA del mouse per lo zoom.",
    quinta: "OK, CHIUDI",
    sesta: "Trascina con un dito per ruotare la camicia.",
    settima: "Trascina con due dita per spostare la camicia.",
    ottava: "Allarga o stringi con due dita per lo zoom.",
  },
  banner: {
    titolo: "Use of Cookies",
    testo1:
      "In this application, we use cookies (or similar technologies) to store information on your computer or mobile device in order to improve your online experience. Cookies are small text files that allow you to navigate efficiently, remember your preferences, help us understand the performance of the application and generally improve your user experience.",
    testo2:
      "By closing this message you consent to the use of cookies based on your (possible) preferences.",
    gestione: "Cookies management",
    acconsento: "I agree",
  },
  sito: {
    titolo: "La tua camicia su misura direttamente dal produttore!",
    sottotitolo:
      "La nostra è un’azienda ad impronta artigianale e negli anni ha condiviso la passione per questo lavoro con un valido gruppo di esperte lavoratrici che con grande spirito di sacrificio ha saputo mantenere i legami con le proprie radici culturali dalla forte tradizione sartoriale.",
    bottone1: "Inizia a creare la tua camicia!",
    titolo2: "Un configuratore 3D senza limiti",
    sottotitolo2:
      "La camiceria Su Misura di Lodi produce e vende per aziende e privati",
    configura: "Configura",
    titolo3: "CAPI DI VERA MODA ARTIGIANALE ITALIANA!",
    sottotitolo3:
      "Offriamo tutta la nostra esperienza per confezionare camicie di qualità interamente fatte a mano secondo la tradizione sartoriale italiana.",
    titolo4: "Qualità delle immagini",
    sottotitolo4:
      "Scegli una camicia su misura, ti garantiamo una",
    titolo5: "VESTIBILITA' PERFETTA",
    sottotitolo5:
      "ed un elevato confort perchè si tratta di un capo tagliato sulla persona in base alla corporatura e alle esigenze specifiche del cliente.",
    sottotitolo6:
      "Per la nostra produzione impieghiamo",
    titolo7: "MATERIE PRIME ECCELLENTI",
    sottotitolo7:
      "100% Cotone doppio ritorto prodotto dalle migliori aziende italiane quali: Albini, Canclini, Canaloni, Monti, Ibieffe, Fratelli Tosetti, Reda e Rubinelli.",
    titolo8: "Senza limiti...",
    sottotitolo8:
      "Bottoni di ottima madreperla, Pvc riciclato e Corozo cuciti sapientemente con cotoni e sete di filati Guttermann e Maidera.",
    titolo9: " Web Marketing",
    sottotitolo9:
      "Continua evoluzione di materiali ecosostenibili.",
    titolo10: "Caratteristiche del configuratore 3D SHIRT",
    sottotitolo10:
      "Tutta la versatilità di una camicia... perfetta in ogni occasione!",
    titolo11: "AMPIA SCELTA",
    sottotitolo11:
      "Privilegia il look che più ti rappresenta! Potrai scegliere il tuo stile tra il vasto assortimento di tessuti e le diverse tipologie di finiture.",
    titolo12: "I NOSTRI SERVIZI",
    serv1tit:"CONTATTO",
    serv2tit:"PRESA IN CARICO ORDINE",
    serv3tit:"CONFEZIONAMENTO",
    serv1des:"Seguiamo il cliente passo dopo passo, dalla presa delle misure alla scelta delle finiture, per realizzare il prodotto che più soddisfi le esigenze richieste.",
    serv2des:"Una modellista esperta prepara e sviluppa il cartamodello della camicia da cui parte il processo di produzione, svolto interamente a mano in ogni passaggio.",
    serv3des:"Una artigiana professionista si occupa della realizzazione del capo avendo cura di ogni singolo dettaglio come le cuciture realizzate a mano.",
    sottotitolo12:
      "L'applicazione è in grado di gestire tutte le fasi del processo d'acquisto, dalla gestione del carrello, e quindi prodotti e codici sconto, fino alla gestione della spedizione e del pagamento.",
    titolo13: "Creazione Account",
    sottotitolo13:
      "L'applicazione prevede la possibilità di creare un profilo utente personale che permetterà all'utente stesso di memorizzare le proprie misure e i propri acquisti.",
    newshop:
      "Da oggi 3D SHIRT permette la vendita di prodotti collegati alla tua sartoria! Non solo camicie personalizzate ma anche camicie pronte, cravatte o quello che vuoi!",
  },
  contact: {
    titolo: "Send us a message",
    sottotitolo:
      "Contact us to request a quote or simply for questions or suggestions. We will get back to you as soon as possible.",
    nome: "Your name",
    telefono: "Your telephone number",
    email: "Your email",
    messaggio: "Leave a message",
    invia: "Send the message",
  },
  header: {
    account: "Account",
    modificapassword: "Change your Password",
    logout: "Logout",
    wishlist: "Wishlist",
    shopping: "Shopping Bag",
    loggedOut: "You are no longer logged in.",
    loggedOutError: "An error has occurred:",
    cambiaPasswordSuccess:
      "We will send you an email containing a unique link to reset your password.",
    cambiaPasswordError: "The following error has occurred:",
  },
  coloriTip: {
    grigio: "Grey",
    blu: "Blue",
    nero: "Black",
    marrone: "Brown",
    verde: "Green",
    bianco: "White",
    viola: "Violet",
    arancione: "Orange",
    beige: "Beige",
    giallo: "Yellow",
    rosa: "Pink",
    rosso: "Red",
  },
  footer: {
    account: "Account",
    login: "Login",
    logout: "Logout",
    cookie: "Cookie Policy",
    privacy: "Privacy Policy",
    termini: "Terms and Conditions",
    recesso: "Right of Withdrawal",
    contattaci: "Contact Us",
    partita: "P.IVA",
  },
  dettaglio: {
    descrizione: "Fabric description",
    comeMisure: "How to take measurements",
    spedizione: "Shipping and return",
  },
  navigazione: {
    lang: "en",
    tessuto: "Fabric",
    scegliTessuto: "Select the fabric",
    inOfferta: "On sale",
    nonDisponibile: "Not available",
    personalizza: "Customize",
    personalizzazione: "Customization",
    polsinoGemelli: "Cufflinks cuff",
    contrastoColletto: "Apply to collar",
    contrastoPolsino: "Apply to cuffs",
    contrastoChiusura: "Apply to button placket",
    chiusura: "Closing",
    colletto: "Collar",
    polsino: "Cuffs",
    taschino: "Pocket",
    pinces: "Pences",
    asole: "Buttonholes",
    bottoni: "Buttons",
    fili: "Thread",
    contrasto: "Contrasts",
    loading: "Loading...",
    mascherina: "Mask",
    maniche: "Sleeves",
    durezzaTitolo: "Collar hardness",
    durezza1: "Stiff",
    durezza2: "Normal",
    durezza3: "Soft",
    durezza4: "Super soft",
    velaTitolo: "Collar leaf",
    vela1: "Leaf 7",
    vela2: "Leaf 7.5",
    vela3: "Leaf 8",
    vela4: "Leaf 8.5",
    vela5: "Leaf 9",
    vela6: "Spaced",
    fondo: {
      titolo: "Fondo Camicia",
      classico: "Classico",
      dritto: "Dritto",
      drittoSpacchi: "Dritto con spacchi",
    },
    iniziali: {
      iniziali: "Monogram",
      inserisciIniziali: "Insert your monogram",
      tueIniziali: "Enter your monogram",
      stile: "Monogram style",
      colore: "Monogram color",
      bianco: "White",
      blu: "Blue",
      celeste: "Light blue",
      grigio: "Grey",
      nero: "Black",
      rosso: "Red",
      verde: "Green",
      arancione: "Orange",
      rosa: "Pink",
      posizione: "Position",
      sopra: "Up",
      centro: "Middle",
      sotto: "Down",
      polsinoSx: "Left cuff",
      polsinoDx: "Right cuff",
      aggiungiIniziali: "Add initials",
      stile1: "style",
      colore1: "color",
      posizione1: "position",
    },
    misure: {
      misuraNeutra: "Test shirt",
      misuraNeutraTitolo: "Do you want to try on the shirt before buying it??",
      misuraNeutraTesto1:
        "Ask for a neutral shirt with the selected sizes, at a price of only € 20.00.",
      misuraNeutraTesto2:
        "The cost of the test shirt will be discounted later on the final order.",
      metodoTitolo: "Select the mode you prefer",
      metodoTaglia: "Measures from standard sizes",
      metodoCorpo: "Measure your body",
      metodoCamicia: "Measure a shirt that suits you",
      metodoInvia: "Send us your shirt to measure it",
      metodoModifica: "Modification",
      metodoInformazioni: "Informations",
      selezionaTaglia: "Select your size",
      selezionaVestibilita: "Select your fit...",
      selezionaCorporatura: "Select your build...",
      selezionaSpalle: "Select the inclination of the shoulders...",
      corporatura: {
        pancia: {
          nome: "Pancia",
          piatta: "Flat",
          regolare: "Regular",
          sporgente: "Bulging",
        },
        spalle: {
          nome: "Spalle",
          alte: "High",
          regolari: "Regular",
          basse: "Low",
        },
      },

      taglie: "SIZE",
      Vita: "Waist",
      lunghezzaCam: "Length",

      misure: "Measurements",
      tueMisure: "Your measurements",
      salva: "Save your measurements",
      errore: "An error has occurred",
      successo: "Measures successfully saved",
      Braccia: "Sleeve",
      Bicipite: "Biceps",
      Avambraccio: "Avambraccio",
      PuntoVitaDietro: "Punto vita dietro",
      LunghezzaDavanti: "Lunghezza Davanti",
      MezzoTorace: "Mezzo Torace",
      PuntoTorace: "Punto Torace",
      MezzaManica: "Mezza Manica",
      Collo: "Neck",
      Girovita: "Waist",
      Polso: "Wrist",
      Spalle: "Shoulders",
      Torace: "Chest",
      Lunghezza: "Length",
      ColloSpalla: "Collo Spalla",
      PettoGiro: "Petto Giro",
      PettoSpalla: "Petto Spalla",
      fianco: "Fianco",
      giroManica: "Giro Manica",
      dimColloSpalla: "Neck - Shoulder",
      PettoGiro: "Chest - Round Size",
      ColloSpalla: "neck - Shoulder",
      fianco: "Side",
      giroManica: "Armhole",
      vuoiAiuto: "Would you like some assistance with your measurements?",
      provaSelezionare: "Try selecting your size",
      successoCarica: "Measures successfully loaded.",
      seleziona: "Select...",
      xs: "XS - 36",
      s: "S - 37/38",
      m: "M - 39/40",
      l: "L - 41/42",
      xl: "XL - 43/44",
      xxl: "XXL - 45/46",
      xxxl: "XXXL - 47/48",
      oppure: "or",
      stoCaricando: "Loading...",
      carica: "Load your measurements",
      inviaTitolo: "Mail a Shirt to Measure",
      inviaParag1:
        "Want to copy the fit of a shirt you already have, but aren’t sure how to measure it properly?",
      inviaParag2:
        "Mail us your shirt and our experts will measure it and create a special saved size in your account for you. *Note that our measuring causes no damage to the shirt and we will return the shirt to you right away.",
      inviaParag3: "Send to:",
      inviaTitolo2: "When sending, be sure to include:",
      inviaLista1: "The shirt you want us to measure",
      inviaLista2: "Your name",
      inviaLista3: "Phone number",
      inviaLista4: "Email address",
      inviaLista5: "Return shipping address",
      inviaLista6: "Any special instructions",
      infoTipoMisure: "Measure mode:",
      infoTipoMisure0: "Measures from standard sizes",
      infoTipoMisure1: "Measurements taken on your body",
      infoTipoMisure2: "Measurements taken from your shirt",
      infoTipoMisure3: "Will send a shirt to have it measured",
      infoTagliaSelezionata: "Chosen size:",
      infoVestibilita: "Fit",
    },
  },
  barraAcquisto: {
    lang: "en",
    camicia: "Shirt",
    nonDisponibile: "Fabric not available.",
    tooltip: "Add this shirt to cart",
    carrello: "Add to cart",
    tessuto: "Fabric ",
    di: " of ",
    aggiunta: "Shirt added to cart.",
    aggiunta1: "Shirt successfully added to cart.",
    aggiunta2: "What do you want to do now??",
    continua: "Continue your shopping",
    vai: "Go to shopping bag",
    wishlist: {
      lang: "en",
      nuovoPrezzo: "New price",
      nonDisponibile: "Caution. Fabric not available!",
      wishlist: "Wishlist",
      vuota: "Your Wishlist is empty!",
      Camicia: "Shirt",
      tooltip: "Add shirt to wishlist",
      successo: "Shirt succesfully added to wishlist.",
      rimossa: "Shirt succesfully removed from wishlist.",
      Prodotto: "Product",
      Prezzo: "Price",
      Descrizione: "Description",
      Tessuto: "Fabric",
      Disegno: "Drawing",
      Colletto: "Collar",
      Italiano: "Italian",
      "Italiano Classico": "Classic Italian",
      "Francese Classico": "Classic French",
      "Francese Semiaperto": "Semi French",
      "Francese Semiaperto due bottoni": "Semi French two buttons",
      "Botton Down Classico": "Button Down",
      "Botton Down Alto due bottoni": "Button Down two buttons",
      Diplomatico: "Smoking",
      Coreano: "Korean",
      "Polsino Arrotondato": "Rounded Cuff",
      "Polsino Smussato": "Beveled Cuff",
      "Polsino Gemelli": "Cufflinks Cuff",
      "Manica Corta": "Short Sleeve",
      Chiusura: "Closing",
      "Faldoncino Interno non Impunturato": "French",
      "Faldoncino Esterno Impunturato": "Standard",
      "Finta Doppia e bottoni nascosti": "Hidden",
      "Nessun Taschino": "No Pockets",
      "Taschino Arrotondato": "Rounded Pocket",
      "Taschino Smussato": "Bevelled Pocket",
      "Due Taschini Arrotondati": "Two Rounded Pockets",
      "Due Taschini Smussati": "Two Bevelled Pockets",
      "Dietro Liscio": "No Darts",
      "Dietro con Doppie Pinces": "Double Darts",
      "Dietro con Doppia Piega": "Double Folds",
      "Asola colore camicia": "Buttonhole in shirt color",
      "Asola Bianca": "White Slot",
      "Asola Blu": "Blue Slot",
      "Asola Celeste": "Light blue Slot",
      "Asola Grigia": "Gray Slot",
      "Asola Nera": "Black Slot",
      "Asola Rossa": "Red Slot",
      "Bottone Bianco": "White Button",
      "Bottone Blu": "Blue Button",
      "Bottone Celeste": "Light blue Button",
      "Bottone Grigio": "Gray Button",
      "Bottone Nero": "Black Button",
      "Bottone Rosso": "Red Button",
      "Filo Bianco": "White Thread",
      "Filo Blu": "Blue Thread",
      "Filo Celeste": "Light blue Thread",
      "Filo Grigio": "Gray Thread",
      "Filo Nero": "Black Thread",
      "Filo Rosso": "Red Thread",
      Contrasto: "Contrast",
      contrastoPolsino: "Cuffs",
      contrastoColletto: "Collar",
      contrastoChiusura: "Closure",
      Stile: "Style",
      Iniziali: "Monogram",
      iniStile: "Style",
      iniColore: "Color",
      iniPosizione: "Position",
      white: "White",
      slateblue: "Blue",
      lightsteelblue: "Light blue",
      lightgray: "Gray",
      black: "Black",
      crimson: "Red",
      posizione: "Position",
      sopra: "Up",
      centro: "Middle",
      sotto: "Down",
      rimuovi: "Remove from Wishlist",
      importa: "Import in the configurator",
      torna: "Back to the configurator",
    },
  },
  tutorial: {
    braccia: {
      header: "Arms",
      titolo: "Arm lenght",
      descrizione:
        "Measure the sleeve from the shoulder to the wrist holding your arm bent at 90°. For accurate measurement, it is necessary to measure from the shoulder to the elbow and proceed to the end of the wrist, where it joins the hand.",
    },
    mezzaManica: {
      header: "Mezza Manica",
      titolo: "Misura della mezza manica",
      descrizione:
        "Misura la manica dalla spalla sino alla lunghezza desiderata per un minimo di 18cm e un massimo di 30cm",
    },
    bicipite: {
      header: "Biceps",
      titolo: "Biceps measurement",
      descrizione:
        "Measure the biceps / triceps at cm. 16 starting from the outer point of the shoulder.",
    },
    avambraccio: {
      header: "avambraccio",
      titolo: "Misura dell'avambraccio",
      descrizione: "Misura l'avambraccio appena sotto il gomito.",
    },
    fianco: {
      header: "Fianco",
      titolo: "Misura del Fianco",
      descrizione:
        "Misura il fianco all'altezza della fine della tasca dei pantaloni passando per l'altezza a meta' dei glutei.",
    },
    puntoVitaDietro: {
      header: "Fianco",
      titolo: "Misura del punto vita dietro",
      descrizione:
        "Misura partendo dall'attaccatura dietro del collo fino ad intercettare il punto più stretto in vita ( misure slim).",
    },
    mezzoTorace: {
      header: "mezzo torace",
      titolo: "Misura del mezzo torace",
      descrizione:
        "Misura la distanza (indossando una camicia ) tra l'attaccatura del carrè al collo scendendo verso il basso (per persone corpulente). ",
    },
    puntoTorace: {
      header: "punto torace",
      titolo: "Misura del punto torace",
      descrizione:
        "Misura dall'attaccatura del carrè al collo fino al capezzolo sul torace ( determina l'altezza del torace).",
    },
    bracciaCamicia: {
      header: "Arms",
      titolo: "Arm lenght",
      descrizione:
        "Measure the sleeve from the seam of the shoulder to the end of the cuff. For accurate measurement, it is necessary to keep the sleeve flat on a flat surface.",
    },
    collo: {
      header: "Neck",
      titolo: "Neck size",
      descrizione:
        "Measure immediately beneath the Adam's apple, sliding the measuring tape around the neck to take the circumference. It is important to insert a finger between the measuring tape and the neck to ensure a comfortable grip.",
    },
    colloCamicia: {
      header: "Neck",
      titolo: "Neck size",
      descrizione:
        "Measure the linear distance between the collar button and the corresponding buttonhole, keeping the collar wide open and lying flat on a flat surface.",
    },
    girovita: {
      header: "Waist",
      titolo: "Waist size",
      descrizione:
        "Measure the waistline at the widest point, at the height of the navel. If you have wide hips it is advisable to take the measurement slightly lower, to measure them in total. For a proper fit, you must adhere to the waistline, always leaving a finger of tolerance between the body and the measuring tape, so that you can sit comfortably. It is important to take the precise measurement, keeping the measuring tape adherent to the body: fit will be given by the style chosen while designing the shirt.",
    },
    girovitaCamicia: {
      header: "Waist",
      titolo: "Waist size",
      descrizione:
        "Measure the waistline at the widest point at the navel, between the second and third buttons from the bottom, keeping the shirt flat on a flat surface. If you have wide hips, it is advisable to take the measurement slightly lower , to include them in the total measurement.",
    },
    polso: {
      header: "Wrist",
      titolo: "Wrist size",
      descrizione:
        "Measure the wrist circumference at the wrist joint. For a proper fit you have to make the measuring tape adhere to the wrist while retaining a finger of tolerance between the wrist and the measuring tape.",
    },
    polsoCamicia: {
      header: "Wrist",
      titolo: "Wrist size",
      descrizione:
        "Measure the linear distance between the cuff button and the corresponding buttonhole, keeping the cuff open and lying flat on a flat surface.",
    },
    spalle: {
      header: "Shoulders",
      titolo: "Shoulders size",
      descrizione: "Measure the shoulders width at the widest point.",
    },
    spalleCamicia: {
      header: "Shoulders",
      titolo: "Shoulders size",
      descrizione:
        "Measure the shoulder width at the widest point, from the seam of the left arm to the seam of the right arm, keeping the shirt flat on a flat surface.",
    },
    torace: {
      header: "Chest",
      titolo: "Chest size",
      descrizione:
        "Measure the chest circumference at nipple height. For a proper fit, you must adhere the measuring tape to the chest, always holding a finger of tolerance between the body and the measuring tape so that you can move freely.",
    },
    toraceCamicia: {
      header: "Chest",
      titolo: "Chest size",
      descrizione:
        "Measure the circumference of the chest at chest height, between the second and third buttons from above. Measure the linear distance between the button and the opposite corresponding buttonhole.",
    },
    lunghezza: {
      header: "Length",
      titolo: "Length",
      descrizione:
        "Tilt your head forward and measure from the center of the back base of the neck, at the most protruding bone, down to 3/4 of the buttocks for a classic length. If you wear a shirt, measure the back side from the center of the collar seam to the bottom hem.",
    },
    lunghezzaCamicia: {
      header: "Length",
      titolo: "Length",
      descrizione:
        "Keeping the shirt flat on a flat surface, measure from the center of the back base of the neck, at the center of the seam between the shirt and collar, to the bottom hem.",
    },
    colloSpalla: {
      header: "Neck - Shoulder",
      titolo: "Neck - Shoulder",
      descrizione:
        "Measure the distance from the attachment of the neck to the end of the shoulder. It is important to decide whether you want a precise 'tailored' or casual 'large' shoulder.",
    },
    pettoGiro: {
      header: "Chest - Round Size",
      titolo: "Chest - Round Size",
      descrizione:
        "Measure the front of your shirt between the second and third buttons up to the sleeve seam.",
    },
    pettoSpalla: {
      header: "Chest - Shoulder Size",
      titolo: "Chest - Shoulder Size",
      descrizione:
        "Measure from the neck to the seam of the sleeve with the shoulder.",
    },
    fianco: {
      header: "Hip",
      titolo: "Hip",
      descrizione: "Measure the hip at the widest point.",
    },
    giroManica: {
      header: "Armhole",
      titolo: "Armhole",
      descrizione:
        "Measure the armholes at shoulder height, leaving a finger between the tape measure and the arm.",
    },
  },
  contatti: {
    richiesto: "Required field",
    emailInvalida: "Invalid email address",
    titolo: "We love to talk with you",
    successo: "Thank you. Your message has been successfully sent.",
    errore: "Caution. An error has occurred.",
    nome: "Name *",
    email: "Email *",
    oggetto: "Subject *",
    messaggio: "Message *",
    attendere: "Wait...",
    invia: "Send",
    testo01:
      "EVERY ORDER REQUIRES AT LEAST 20 WORKING DAYS BEFORE SHIPPING. WE APOLOGIZE FOR THIS ANNOYANCE BUT YOUR SHIRT WILL NOT BE LIKE ALL THE OTHERS.",
    testo02:
      "Sartoria Turrisi is in Ceglie Messapica, a welcoming town in the Province of Brindisi, in the south of Puglia.",
    testo03:
      "Since 1970 our strong sartorial tradition has been handed down from father to son: we are a small artisan company that operates with passion at every stage of production, which is carried out exclusively within our tailor's shop by highly specialized Italian artisans.",
    testo04:
      'The choice of fabrics and accessories of the highest quality allow us to offer the excellence of the authentic "Made in Italy".',
    testo05:
      "Our goal is to satisfy our client in every aspect, putting our long experience at his disposal.",
    testo06:
      "Today, it is possible to confuse a sculptor with a tailor, because both create shapes.",
    testo07: "KARL KRAUS",
    testo08: "FEEL OUR FABRIC SELECTION WITH YOUR HANDS!",
    testo09: "ORDER YOUR FREE KIT NOW!",
  },
  pagina404: {
    errore: "Error 404",
    nonEsiste: "The page you are looking for does not exist!",
    torna: "Back to configurator",
  },
};
